import WritingTest from "./WritingTest";

export default WritingTest;
